import { CalendarSkeleton } from './loading';
import PageHeader from '@/components/PageHeader';
import SubContainer from '@/components/Container/SubContainer';
import { useCalendarStore } from './store/useCalendarStore';
import { useEffect } from 'react';
import { ErrorPage } from '@/components/ErrorPage';
import Container from '@/components/Container';
import Divider from '@/components/Divider';
import Button from '@/components/Button';
import { CalendarContainer } from './components/calendar-container';
import { useLocation, useNavigate } from 'react-router-dom';
import { trackGAEvent } from '@/lib/ga-custom-events/dispatcher';

const CalendarPageComponent = () => {
  const { onInit, page, loading, error } = useCalendarStore((state) => ({
    onInit: state.onInit,
    page: state.page,
    loading: state.loading,
    error: state.error,
  }));
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/calendar/') {
      const date = new Date();
      const currentMonth = date.toLocaleString('default', { month: 'long' }).toLowerCase();
      navigate(`/calendar/${currentMonth}`);
      return;
    }
  }, [navigate, location.pathname]);

  useEffect(() => {
    onInit();
  }, [onInit]);

  if (loading) {
    return <CalendarSkeleton />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <>
      <Container className="mt-sh-60 !gap-y-0">
        <SubContainer className="lg:col-start-11 lg:col-end-3">
          <PageHeader title={page?.title || ''} url="/" type="none" />
        </SubContainer>
        <SubContainer className="mt-sh-15 lg:col-start-11 lg:col-end-3">
          <h1 className=" !mb-sh-15 font-cadiz text-sh-28-32 !font-bold">{page?.title || ''}</h1>
          <p className=" font-cadiz text-sh-18-24">{page?.description || ''}</p>
          <Divider className="!my-sh-15 !mt-sh-30" />
          {page?.file?.url && (
            <Button
              className="mb-sh-15"
              onClick={() => {
                trackGAEvent('calendar_pdf_downloaded', {});
                window.open(page?.file?.url, '_blank');
              }}>
              {page?.downloadButtonText || ''}
            </Button>
          )}
          <CalendarContainer />
        </SubContainer>
      </Container>
    </>
  );
};

export default CalendarPageComponent;
